import { SYSTEM_ROLES, USER_STATUSES } from '../constants';
import {
  NO_GROUP_FILTER_OPTION_ID,
  NO_LOCATION_FILTER_OPTION_ID,
  NO_POSITION_FILTER_OPTION_ID,
} from '../../../../shifts/constants';

import employeeFiltersUrl from './employeeFilters.html';

class EmployeeFiltersController {
  systemRoles = SYSTEM_ROLES;
  statuses = USER_STATUSES;

  constructor(PersonaCollection, Authentication, $scope) {
    'ngInject';

    Object.assign(this, { PersonaCollection, Authentication, $scope });
  }

  $onInit() {
    this.setFilterPersonas();

    this.allFilters = this._getAllFilters();
    if (this.Authentication.user.clientcache?.employeeFilters) {
      this.filters = this.Authentication.user.clientcache.employeeFilters;
    } else {
      this.filters = this._getDefaultFilter();
      this._updateFiltersInCache();
    }

    this.changeFilters();
  }

  setFilterPersonas() {
    this.locations = [...this.PersonaCollection.visibleLocations];
    this.positions = [...this.PersonaCollection.positions];
    this.groups = [...this.PersonaCollection.groups];

    this.locations.push({ id: NO_LOCATION_FILTER_OPTION_ID, name: 'No locations' });
    this.positions.push({
      id: NO_POSITION_FILTER_OPTION_ID,
      name: 'No positions',
      color: '#97A2AE',
    });
    this.groups.push({ id: NO_GROUP_FILTER_OPTION_ID, name: 'No groups' });
  }

  changeFilters() {
    this.onFiltersChange({ filters: this.filters });
    this.filtersActive = this._areFiltersActive();
  }

  _areFiltersActive() {
    return Object.values(this.filters).some((val) => val?.length);
  }

  toggleFilter(type, identifier, selectOnlyThis) {
    if (!(type in this.filters)) {
      this.filters[type] = [];
    }

    const typeFilters = this.filters[type];
    if (!typeFilters.length) {
      this.filters[type] = selectOnlyThis
        ? [identifier]
        : this.allFilters[type].filter((f) => f !== identifier);
    } else {
      this._changeFilterSelection(type, identifier);
    }

    this._updateFiltersInCache();
  }

  _changeFilterSelection(type, identifier) {
    const index = this.filters[type].findIndex((item) => item === identifier);
    if (index >= 0) {
      this.filters[type].splice(index, 1);
    } else if (this.filters[type].length >= this.allFilters[type].length - 1) {
      // if all filters are selected - empty the array
      this.filters[type] = [];
    } else {
      this.filters[type].push(identifier);
    }
  }

  _getDefaultFilter() {
    return {
      locationIds: [],
      positionIds: [],
      roles: [],
      statuses: [],
    };
  }

  _getAllFilters() {
    return {
      locationIds: this.locations.map((location) => location.id),
      positionIds: this.positions.map((position) => position.id),
      groupIds: this.groups.map((group) => group.id),
      roles: this.systemRoles.map((role) => role.id),
      statuses: this.statuses.map((status) => status.id),
    };
  }

  _updateFiltersInCache() {
    this.Authentication.user.clientcache.employeeFilters = this.filters;
    this.Authentication.syncClientCache();
    this.changeFilters();
  }

  clearFilter(type) {
    if (!type) {
      return;
    }

    this.filters[type] = [];
    this._updateFiltersInCache();
  }

  clearAllFilters() {
    this.filters = this._getDefaultFilter();
    this._updateFiltersInCache();
  }
}

export default {
  controllerAs: 'ctrl',
  controller: EmployeeFiltersController,
  templateUrl: employeeFiltersUrl,
  bindings: {
    filters: '=',
    filtersEmpty: '<',
    statusFilterVisible: '<',
    onFiltersChange: '&',
  },
};
